export default "__VITE_ASSET__gqrKd_lJ__"